import React from 'react';
import { Container, Grid, Typography, Link, IconButton } from '@mui/material';
import { Facebook, Twitter, LinkedIn, Instagram } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import './Footer.css';
import logoimg from "../assets/images/Krinvy_Logo.png";
import logoimg1 from "../assets/images/msme.png";
import logoimg2 from "../assets/images/startup_india.png";
import logoimg3 from "../assets/images/digital_india.png";
import logoimg4 from "../assets/images/google_reviews.png";
// import logoimg5 from "../assets/images/dmca_protected.png";  // Temporarily commented out

const Footer = () => {
  const navigate = useNavigate();

  const handleCall = () => {
    window.location.href = "tel:+917842748997";
  };

  const openGoogleMaps = () => {
    window.open("https://www.google.com/maps/place/Ameerpet,+Hyderabad,+Telangana,+India/@17.4348105,78.4480742,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcb9753d3f1b2fb:0xf0b8c4e8a490ab35!8m2!3d17.4348054!4d78.4506491!16s%2Fm%2F027zcn_?entry=ttu", "_blank");
  };

  const handleProductNavigation = (hash) => {
    navigate(`/products${hash}`);
    window.scrollTo(0, 0);  // Changed from reload() to scrollTo()
  };

  return (
    <footer className="footer">
      <Container>
        {/* First Row */}
        <Grid container spacing={4} className="footer-row">
          {/* Company Info (Centered) */}
          <Grid item xs={12} md={4} className="company-info">
            <div className="company-info-content">
              <img src={logoimg} alt="Krinvy Consulting Pvt Ltd Logo" className="footer-logo-img" />
              <Typography variant="h5" className="footer-titlee">Krinvy</Typography>
              <Typography variant="body2" className="footer-text">
                Create. Innovate. Accelerate.
              </Typography>
              <div className="social-icons">
                <IconButton href="https://facebook.com" target="_blank" className="social-icon"><Facebook /></IconButton>
                <IconButton href="https://twitter.com" target="_blank" className="social-icon"><Twitter /></IconButton>
                <IconButton href="https://linkedin.com" target="_blank" className="social-icon"><LinkedIn /></IconButton>
                <IconButton href="https://instagram.com" target="_blank" className="social-icon"><Instagram /></IconButton>
              </div>
            </div>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} md={4} className="footer-section">
            <Typography variant="h6" className="footer-title">Quick Links</Typography>
            <div className="footer-links">
              <Link href="/" color="inherit" underline="none">Home</Link>
              <Link href="/about" color="inherit" underline="none">About Us</Link>
              <Link href="/careers" color="inherit" underline="none">Career</Link>
              <Link href="/become_a_partner" color="inherit" underline="none">Become A Partner</Link>
              <Link href="/terms" color="inherit" underline="none">Terms & Conditions</Link>
              <Link href="/privacy" color="inherit" underline="none">Privacy Policy</Link>
              <Link href="/refundpolicy" color="inherit" underline="none">Refund Policy</Link>
            </div>
          </Grid>

          {/* Services */}
          <Grid item xs={12} md={4} className="footer-section">
            <Typography variant="h6" className="footer-title">Services</Typography>
            <div className="footer-links">
              <Link href="/services" color="inherit" underline="none">Business Registration & Compliance</Link>
              <Link href="/services" color="inherit" underline="none">Financial & Tax Services</Link>
              <Link href="/services" color="inherit" underline="none">Web & E-commerce Development</Link>
              <Link href="/services" color="inherit" underline="none">Digital Marketing & SEO</Link>
              <Link href="/services" color="inherit" underline="none">Branding & Graphic Design</Link>
              <Link href="/services" color="inherit" underline="none">Social Media Management</Link>
              <Link href="/services" color="inherit" underline="none">Business Strategy & Consulting</Link>
            </div>
          </Grid>
        </Grid>

        {/* Second Row */}
        <Grid container spacing={4} className="footer-row">
          {/* Products */}
          <Grid item xs={12} md={4} className="footer-section">
            <Typography variant="h6" className="footer-title">Solutions by Industry</Typography>
            <div className="footer-links">
              <Link 
                color="inherit" 
                underline="none"
                onClick={() => handleProductNavigation('#business-operations')}
                style={{ cursor: 'pointer' }}
              >
                Business & Operations
              </Link>
              <Link 
                color="inherit" 
                underline="none"
                onClick={() => handleProductNavigation('#healthcare-wellness')}
                style={{ cursor: 'pointer' }}
              >
                Healthcare & Wellness
              </Link>
              <Link 
                color="inherit" 
                underline="none"
                onClick={() => handleProductNavigation('#education-learning')}
                style={{ cursor: 'pointer' }}
              >
                Education & Learning
              </Link>
              <Link 
                color="inherit" 
                underline="none"
                onClick={() => handleProductNavigation('#commerce-retail')}
                style={{ cursor: 'pointer' }}
              >
                Commerce & Retail
              </Link>
              <Link 
                color="inherit" 
                underline="none"
                onClick={() => handleProductNavigation('#professional-services')}
                style={{ cursor: 'pointer' }}
              >
                Professional & Creative Services
              </Link>
              <Link 
                color="inherit" 
                underline="none"
                onClick={() => handleProductNavigation('#finance-utility')}
                style={{ cursor: 'pointer' }}
              >
                Finance & Utility
              </Link>
              <Link 
                color="inherit" 
                underline="none"
                onClick={() => handleProductNavigation('#tax-legal')}
                style={{ cursor: 'pointer' }}
              >
                Tax & Legal Services
              </Link>
            </div>
          </Grid>

          {/* Outsourcing */}
          <Grid item xs={12} md={4} className="footer-section">
            <Typography variant="h6" className="footer-title">Outsourcing</Typography>
            <div className="footer-links">
              <Typography variant="subtitle2" className="footer-subtitle">U.S. Accounting & Taxation:</Typography>
              <Link href="/Outsourcing" color="inherit" underline="none">Bookkeeping</Link>
              <Link href="/Outsourcing" color="inherit" underline="none">Tax Preparation</Link>
              <Link href="/Outsourcing" color="inherit" underline="none">Payroll Processing</Link>
              
              <Typography variant="subtitle2" className="footer-subtitle">Indian Accounting & Taxation:</Typography>
              <Link href="/Outsourcing" color="inherit" underline="none">GST Filing</Link>
              <Link href="/Outsourcing" color="inherit" underline="none">Income Tax Filing</Link>
              
              <Typography variant="subtitle2" className="footer-subtitle">Digital Services:</Typography>
              <Link href="/Outsourcing" color="inherit" underline="none">Website Development</Link>
               <Link href="/Outsourcing" color="inherit" underline="none">Web Application Development</Link>
                  <Link href="/Outsourcing" color="inherit" underline="none">Mobile Application Development</Link>
              <Link href="/Outsourcing" color="inherit" underline="none">Digital Marketing Content</Link>
            </div>
          </Grid>

          {/* Get In Touch & Addresses */}
          <Grid item xs={12} md={4} className="footer-section">
            <Typography variant="h6" className="footer-title">Get In Touch</Typography>
            <div className="footer-links">
              {/* <Link onClick={handleCall} color="inherit" underline="none" style={{ cursor: 'pointer' }}>Call Us: +91 7842748997</Link> */}
              <Link href="mailto:info@krinvy.com" color="inherit" underline="none">Email: info@krinvy.com</Link>
              <Link onClick={openGoogleMaps} color="inherit" underline="none" style={{ cursor: 'pointer' }}>Locate Us</Link>

              <Typography variant="subtitle2" className="footer-subtitle" style={{ marginTop: '15px' }}>Registered Address:</Typography>
              <Typography variant="body2" className="address-text">
                KRINVY Consulting Pvt Ltd.<br />
                20-3/1-93, Flat No. Gf-3, Ground Floor,<br />
                Siva Sadanamu, New Ayodhya Nagar,<br />
                Vijayawada, Andhra Pradesh, Pin Code: 520003, India.
              </Typography>

              <Typography variant="subtitle2" className="footer-subtitle" style={{ marginTop: '15px' }}>Operational Office:</Typography>
              <Typography variant="body2" className="address-text">
                KRINVY Consulting Pvt Ltd.<br />
                RR Heights, Flat No 102, 7-1-414/8,<br />
                East Srinivas Nagar Colony, Ameerpet,<br />
                Hyderabad, Telangana 500038, India.
              </Typography>
            </div>
          </Grid>
        </Grid>

        {/* Credibility Badges */}
        <Grid container className="credibility-badges">
          <Grid item xs={12}>
            <div className="badges-container">
              <img src={logoimg1} alt="Google Rating" className="credibility-badge" />
              <img src={logoimg2} alt="MSME Registered" className="credibility-badge" />
              <img src={logoimg3} alt="Digital India" className="credibility-badge" />
              <img src={logoimg4} alt="Startup India" className="credibility-badge" />
              {/* Temporarily removed DMCA badge */}
              {/* <img src={logoimg5} alt="DMCA Protected" className="credibility-badge" /> */}
            </div>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Grid container justifyContent="center" className="footer-bottom">
          <Grid item>
            <Typography variant="body2" className="footer-copyright">
              © {new Date().getFullYear()} Krinvy Consulting Pvt Ltd. All Rights Reserved.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </footer>
  );
};

export default Footer;